import { TReduxActions } from '../../types/redux';
import { IDeveloperV2 } from '../../types/developerV2/developer';
import { EReviewActionTypes } from '../../actions/reviews/actions';
import { changeReviewReactionType } from './utils/changeReviewReactionType';

export const developerV2Reducer =
  (initState: IDeveloperV2) =>
  (state: IDeveloperV2 = initState, action: TReduxActions): IDeveloperV2 => {
    switch (action.type) {
      case EReviewActionTypes.SetReviewReaction: {
        const { payload } = action;

        return changeReviewReactionType(state, payload);
      }

      default:
        return state;
    }
  };
